module.exports = __webpack_public_path__ + "img/Natnael.2fc0025b.jpg";